<template>
  <b-tooltip
    :active="displayToolTip"
    :label="user.full_name"
    :position="position"
    type="is-dark"
  >
    <div
      :class="['avatar', {'vert-centered': vertCentered}]"
      :style="styleObject"
    >
      <div class="avatar-content">
        <img
          v-if="user.avatar_url"
          :style="styleObject"
          :src="user.avatar_url"
          :alt="user.full_name"
        >

        <span
          v-else
          class="tag is-secondary"
          :style="styleObject"
        >{{ initials }}</span>
      </div>
    </div>
  </b-tooltip>
</template>

<script>
export default {
  name: "AppAvatar",
  props: {
    userId: {
      type: Number,
      required: true
    },
    position: {
      type: String,
      default: 'is-bottom'
    },
    size: {
      type: Number,
      default: 32
    },
    vertCentered: {
      type: Boolean,
      default: false
    },
    displayToolTip: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    user() {
      return this.$store.getters.users.find(u => u.id === this.userId);
    },
    initials() {
      return this.user.first_name.charAt(0) + this.user.last_name.charAt(0);
    },
    styleObject() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        maxHeight: this.size + 'px',
        fontSize: (this.size * 0.6) + 'px',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.avatar {
  overflow: hidden;
  display: inline-block;
  padding: 0;
  margin: 0;
  border-radius: 50%;
  font-weight: bold;
  text-align: center;
  letter-spacing: 1px;
  cursor: default;
}

.vert-centered {
  position: relative;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
